import React, { useEffect, useState } from 'react';
import logo from "./../../../assets/images/logo1.png";
import ShopIcon from './../../../assets/images/ShopIcon.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import $ from "jquery";
import ShowPasswordClose from "./../../../assets/icons/show-password-icon-close.png";
import ShowPasswordOpen from "./../../../assets/icons/show-password-icon-open.png";
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import FooterContact from '../FooterContact';


const CryptoJS = require("crypto-js");

const StepThree = () => {

    const [password, setPassword] = useState({
        password: "",
        confirmPassword: ""
    });
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [apiData, setApiData] = useState([]);

    const [currentData, setCurrentData] = useState({
        email: "",
        otp: "",
        expire: ""
    })


    let navigate = useNavigate();
    const { state } = useLocation();
    const [opt, setOtp] = useState("");

    useEffect(() => {

        // Check OTP page access is valid or not
        if (state === null || state.otpNumber === undefined || state.otpNumber === "" || state.otpNumber === null) {
            navigate("/forget-password-step-one");
            return;
        }


        setOtp(state.otpNumber.join(""));



        let is_valid_request = window.localStorage.getItem("fp");

        if (is_valid_request === null || is_valid_request === undefined || is_valid_request === "") {
            navigate("/forget-password-step-one");
            return;
        }

        let is_valid_request_core = JSON.parse(CryptoJS.AES.decrypt(is_valid_request, process.env.REACT_APP_SECURITY_SALT).toString(CryptoJS.enc.Utf8));


        const now = moment().add(2, "Minutes").format("YYYY-MM-DD HH:mm:ss");
        if (is_valid_request_core?.expire < now) {
            window.localStorage.clear();
            toast.error("OTP time expire !");
            return navigate("/forget-password-step-one");
        }


        setCurrentData(is_valid_request_core);



        if (isLoaded === true) {
            if (error) {
                toast.error(error.messages);
                return;
            }

            let response = JSON.stringify(apiData);
            response = JSON.parse(response);

            if (response["code"] === 200) {
                alert("New Password has been update.");
                window.localStorage.clear();
                return navigate("/");
            }

            toast.error(response["messages"].toString());
        }

    }, [apiData, error, isLoaded, navigate, state]);


    async function fetchData() {
        await fetch(process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_PREFIX + "panel/forget-password/execute", {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),

            body: JSON.stringify({
                email_address: currentData?.email,
                password: password.password,
                confirm_password: password.confirmPassword,
                otp: opt ?? ""
            })

        }).then(res => res.json()).then(
            (result) => {
                setIsLoaded(true);
                setApiData(result);
            },
            (error) => {
                setIsLoaded(true);
                setError(error);
            }
        );
    }


    var handleChange = (e) => {
        setPassword({ ...password, [e.name]: e.value })
    }

    const handleSubmit = e => {
        e.preventDefault();

        if (password.password.length < 8 || password.password.length > 32) {
            toast.error("Password must be between 8 to 32 character long.");
            return;
        }

        if (password.password === password.confirmPassword) {
            fetchData();
            return;
        }

        toast.error("Password and confirm password does not match.");
        return;

    }


    var showPassword = (id) => {
        $(".show-password-icon").hide();

        if ($("#" + id).attr("type") === "text") {
            $(".show-password-icon").eq(0).show();
            $("#" + id).attr("type", "password");
            return;
        }

        $(".show-password-icon").eq(1).show();
        $("#" + id).attr("type", "text");
        return;
    }
    const showConfirmPassword = (id) => {
        $(".show-confirm-pass-icon").hide();

        if ($("#" + id).attr("type") === "text") {
            $(".show-confirm-pass-icon").eq(0).show();
            $("#" + id).attr("type", "password");
            return;
        }

        $(".show-confirm-pass-icon").eq(1).show();
        $("#" + id).attr("type", "text");
        return;
    }

    // Button opacity control on input filled

    $("input[type='password']").on("input", function () {
        canChangeColor();
    });


    function canChangeColor() {

        var can = true;

        $("input[type='password']").each(function () {
            if ($(this).val() === '') {
                can = false;
            }
        });

        if (can) {
            $('.btn').css({ opacity: '1' })
            $('.btn').attr("disabled", false);
        } else {
            $('.btn').css({ opacity: '0.6' })
            $('.btn').attr("disabled", true);
        }
    }






    return (
        <section className="h-screen bg-white font-murecho">
            <ToastContainer />
            <div className="h-full justify-center">
                {/* <!-- Left column container with background--> */}


                <div className='flex justify-center'>
                    <img src={logo} alt="" className='absolute top-12' />
                </div>


                <div
                    className="g-6 flex h-full flex-wrap items-center justify-center lg:justify-center">
                    <div
                        className="shrink-1 mb-12 grow-0 basis-auto md:mb-0 ">
                        <img
                            src={ShopIcon}
                            className="hidden mb-10 lg:block"
                            alt="ShareTrip Partner Portal" />

                    </div>

                    {/* <!-- Right column container --> */}
                    <div className="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">

                        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">

                            <div className="w-full bg-[#1882FF] rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
                                <div className="p-6 sm:p-10">

                                    <p className='text-white text-xl'>Welcome to</p>

                                    <p className="text-xl mb-4 font-semibold leading-8 text-white md:text-[28px] dark:text-white">
                                        ShareTrip Partner Portal
                                    </p>

                                    <p className='text-white font-medium text-sm mb-6'>Enter new password and confirm password</p>

                                    <form onSubmit={handleSubmit} method="POST">
                                        <div className='mb-5'>
                                            <input type="password" name="password" id="password" placeholder="New Password" minLength={8} maxLength={32} onChange={(e) => handleChange(e.target)} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 " required="" />

                                            <img alt="Show Password" className="show-password-icon" src={ShowPasswordOpen} onClick={() => showPassword("password")} style={{ position: "relative", top: "5px", right: "5px" }} />
                                            <img alt="Show Password" style={{ display: "none", position: "relative", top: "7px", right: "7px" }} className="show-password-icon" src={ShowPasswordClose} onClick={() => showPassword("password")}></img>
                                        </div>

                                        <div className='mb-5'>
                                            <input type="password" name="confirmPassword" id="confirmPassword" placeholder="Confirm Password" minLength={8} maxLength={32} onChange={(e) => handleChange(e.target)} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 " required="" />

                                            <img alt="Show Password" className="show-confirm-pass-icon" src={ShowPasswordOpen} onClick={() => showConfirmPassword("confirmPassword")} style={{ position: "relative", top: "5px", right: "5px" }} />
                                            <img alt="Show Password" style={{ display: "none", position: "relative", top: "7px", right: "7px" }} className="show-confirm-pass-icon" src={ShowPasswordClose} onClick={() => showConfirmPassword("confirmPassword")}></img>
                                        </div>

                                        <button className="btn w-full mb-3 text-white bg-[#003897] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg px-6 py-3 text-center opacity-60">Next</button>
                                    </form>
                                </div>
                            </div>

                            <FooterContact />
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default StepThree;